import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import { collection, getDocs } from "firebase/firestore";
import startBg from "../../assets/images/startBg.jpg";
import { Header } from "../HomeScene";
import Loader from "../../components/Loader/Loader";
import { Link, useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";
import { sortAscending } from "../../utils";

function TastingNotes({ db }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [controlsOpacity, setControlsOpacity] = useState({
    left: false,
    right: true
  })
  const [imgLoaded, setImageLoaded] = useState(false);
  let navigate = useNavigate();
  const listRef = useRef(null);

  const fetchData = useCallback(async () => {
    let fetchedData = [];
    setLoading(true);
    const querySnapshot = await getDocs(collection(db, "tastingNotes"));
    querySnapshot.forEach((doc) => {
      fetchedData.unshift(doc.data());
    });
    setData(fetchedData[0]);
    setLoading(false);
  }, [db]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleScroll = (direction) => {
    if (direction === -1) {
      setControlsOpacity({
        left: false,
        right: true
      })
    } else {
      setControlsOpacity({
        left: true,
        right: false
      })
    }

    let tastingCard = document.getElementById("tastingCard");
    listRef.current.scroll({
      left: tastingCard?.clientWidth * direction + direction * 50,
      behavior: "smooth",
    });
  };



  let innerHeight = window.innerHeight;
  const { intro = "", collection: wineCollection = [] } = data || {};
  const SortedWinesList = sortAscending(wineCollection)

  const showControls = wineCollection.length > 4;
  return (
    <div
      className={styles.historyWrapper}
      style={{
        backgroundImage: `url(${startBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        transition: "all ease .8s",
        overflow: "hidden",
        color: "#fff",
        position: "relative",
        minHeight: innerHeight,
      }}
    >
      <Header />
      {loading ? (
        <Loader />
      ) : (
        <div className={styles.notesWrapper}>
          <div className={styles.container}>
            <Link className={styles.closeIconDesktop} to="/brand-experience">
              <img src={require("../../assets/images/close.png")} />
            </Link>
            <div className={styles.introCard}>
              <div className={styles.cardHeader}>THE PENFOLDS TASTE</div>
              <h3>{intro}</h3>
              <Link className={styles.closeIconMobile} to="/brand-experience">
                <img src={require("../../assets/images/close.png")} />
              </Link>
            </div>
            {/* <div className={styles.collectionWrapper}>
            </div> */}
            <div className={styles.carousel}>
              {showControls && (
                <div
                  className={`${styles.leftArrow} ${styles.controls}`}
                  style={{ opacity: controlsOpacity.left ? 1 : 0.5 }} 
                  onClick={() => handleScroll(-1)}
                >
                  <img src={require("../../assets/images/left.png")} />
                </div>
              )}
              <div
                className={styles.tastinglist}
                ref={listRef}
                style={{
                  maxHeight: innerHeight - 425,
                }}
                id="tastingCard"
              >
                {SortedWinesList.map((drink, index) => {
                  const { name = "", imgUrl = "", intro: tag = "" } = drink;
                  return (
                    <Popup
                      key={index}
                      trigger={
                        <button
                          style={{
                            background: "none",
                            border: "none",
                            color: "#fff",
                          }}
                          className={styles.card}
                        >
                          <div
                            onClick={() =>
                              navigate("/detail", { state: { details: drink } })
                            }
                            className={styles.collectionCard}
                          >
                           {imgUrl&& <img
                              src={imgUrl}
                              style={{ display: imgLoaded ? "block" : "none" }}
                              alt={name}
                              className={styles.wineImg}
                              onLoad={() => setImageLoaded(true)}
                            />}
                            <div
                              className={styles.placeHolder}
                              style={{
                                height: !loading && !imgLoaded ? "250px" : 0,
                                minWidth: !loading && !imgLoaded ? "125px" : 0,
                              }}
                            />
                            <div className={styles.drinkName}>
                              {drink?.name}
                            </div>
                          </div>
                        </button>
                      }
                    ></Popup>
                    // <div
                    //   key={index}
                    //   className={styles.card}
                    //   onClick={() =>
                    //     navigate("/detail", { state: { details: drink } })
                    //   }
                    // >
                    //   <div className={styles.collectionCard}>
                    //     <img
                    //       src={imgUrl}
                    //       style={{ display: imgLoaded ? "block" : "none" }}
                    //       alt={name}
                    //       className={styles.wineImg}
                    //       onLoad={() => setImageLoaded(true)}
                    //     />
                    //     <div
                    //       className={styles.placeHolder}
                    //       style={{
                    //         height: !loading && !imgLoaded ? "75px" : 0,
                    //         minWidth: !loading && !imgLoaded ? "125px" : 0,
                    //       }}
                    //     />
                    //     <div className={styles.drinkName}>{drink?.name}</div>
                    //   </div>
                    // </div>
                  );
                })}
              </div>
              {showControls && (
                <div
                  className={`${styles.rightArrow} ${styles.controls}`}
                  style={{ opacity: controlsOpacity.right ? 1 : 0.5 }}
                  onClick={() => handleScroll(2)}
                >
                  <img src={require("../../assets/images/right.png")} />
                </div>
              )}
            </div>
            <div className={styles.downImg}><img src={require("../../assets/images/left.png")} /></div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TastingNotes;
